export default {
  appointment: 'rendez-vous',
  at: 'à',
  back: 'revenir',
  closed: 'fermé',
  closeAt: 'ferme à',
  emergency: 'urgences',
  'except-kids': 'non disponible pour les enfants',
  'except-treatment': 'traitement non disponible',
  for: 'pour',
  form: {
    fields: {
      firstName: 'prénom',
      lastName: 'nom',
      phone: 'téléphone',
      email: 'e-mail',
    },
    validation: {
      firstName: {
        required: 'le prénom est requis',
      },
      lastName: {
        required: 'le nom est requis',
      },
      phone: {
        required: 'le téléphone est requis',
      },
      email: {
        required: 'l\'email est requis',
        email: 'entrez un email valide',
      },
    },
  },
  'i-am-a-new-patient': 'je suis un nouveau patient',
  'i-wish': 'je souhaite consulter',
  infos: 'infos',
  message: 'message',
  'my-appointment-in': 'mon rendez-vous à',
  'my-appointment-for': 'mon rendez-vous pour',
  no: 'non',
  open: 'ouvert',
  openAt: 'ouvre à',
  personTypes: {
    adult: 'un.e adulte (dès 18 ans)',
    kid: 'un.e enfant (jusqu\'à 15 ans)',
    teenager: 'un.e adolescent.e (16-18 ans)',
  },
  send: 'envoyer',
  step4: {
    infos: 'En cliquant sur « Envoyer », vous nous transmettez votre demande de RDV. Ajoutez ici un commentaire si vous le souhaitez (par exemple un horaire de préférence, le nom d’un dentiste que vous souhaitez avoir pour votre traitement ou toutes autres informations utiles à votre demande de rdv',
    'see-you-soon': 'A tout bientôt,',
    signature: 'La Team Adent',
    'thank-you': 'Votre message a bien été transmis ! Nous allons vous contacter sous peu afin de vous proposer un rendez-vous selon votre demande. A bientôt!',
    'you-can-leave': 'Vous pouvez à présent quitter cette fenêtre.',
  },
  'take-appointment': 'prendre rendez-vous',
  'there-for-you': 'Là pour vous',
  where: 'où',
  yes: 'oui',
}
